import { Platform } from 'react-native';

const INTENDED_URL_KEY = 'talents_intended_url';

export const setIntendedUrl = (url: string): void => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try { sessionStorage.setItem(INTENDED_URL_KEY, url); } catch {}
  }
};

export const getAndClearIntendedUrl = (): string | null => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      const url = sessionStorage.getItem(INTENDED_URL_KEY);
      sessionStorage.removeItem(INTENDED_URL_KEY);
      return url;
    } catch {
      return null;
    }
  }
  return null;
};
